var _polygon, _polygon2, _polygon3, _polygon4, _polygon5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTensorFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffa000",
    points: "16,39.609 23,43.609 23,4 16,8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffa000",
    points: "23,12.433 6,22.25 6,13.75 23,3.933"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffb300",
    points: "32,39.609 25,43.609 25,4 32,8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffb300",
    points: "25,12.433 42,22.25 42,13.75 25,3.933"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffb300",
    points: "29,19.732 29,27.365 36,31.407 36,23.775"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensorFlow);
export default __webpack_public_path__ + "static/media/TensorFlow.d978d6b0a450f5416ab4aa62d3795a0c.svg";
export { ForwardRef as ReactComponent };